import { isEqual } from "lodash";
import { memo } from "react";
import { preStaticUrl } from "../../../../constants/env_config";
import "./Partners.scss";
import HomeSection from "../widget/HomeSection/HomeSection";
import PartnerCarousel from "./PartnerCarousel";
import { useCustomTranslation } from "../../../../hooks/useCustomTranslation";

const partnerList01 = [
  "Group_1312319991",
  "Frame_3689",
  "Frame_3709",
  "Frame_3708",
  "Frame_3717",
  "Frame_3720",
  "Frame_3710",
  "Litentry",
  "Nexus",
  "Orochi_Network",
  "Sonic",
  "UXUY",
  "/partners/alaya-ai.jpg",
  "/partners/arai.png",
  "/partners/aster-ai.png",
  "/partners/viy.jpg",
  "/partners/xpin.png",
  "ZeroBase",
  "Frame_3721",
  "Frame_3684",
  "Frame_3686",
  "Frame_3687",
  "Group_1312319992",
  "Group_1312319993",
  "Frame_3713",
  "Frame_3714",
  "Frame_3712",
];
const partnerList02 = [
  "Group_1312319994",
  "Group_1312319995",
  "Frame_3715",
  "Frame_3716",
  "Frame_3692",
  "Frame_3711",
  "Frame_3718",
  "B²_Network",
  "B3",
  "Cycle_Network",
  "DoraHacks",
  "/partners/bas.jpg",
  "/partners/deep-safe.png",
  "/partners/smart-ai.jpg",
  "/partners/ultivers.png",
  "/partners/zk-pass.jpg",
  "efrogs",
  "Frame_3688",
  "Frame_3683",
  "Frame_3685",
  "Frame_3694",
  "Frame_3695",
  "Frame_3696",
  "Frame_3697",
];
const partnerList03 = [
  "Group_1312319996",
  "Group_1312319997",
  "Frame_3693",
  "Frame_3698",
  "Frame_3699",
  "Frame_3700",
  "Frame_3701",
  "Frame_3702",
  "Cogitent_Ventures",
  "Expander",
  "Fireverse",
  "Gravity",
  "KODO",
  "Linpuss",
  "/partners/hela-labs.png",
  "/partners/hybrid.png",
  "/partners/infinity-ground.png",
  "/partners/mira.jpg",
  "/partners/pundi-ai.jpg",
  "Frame_3719",
  "Frame_3722",
  "Frame_3703",
  "Frame_3704",
  "Frame_3705",
  "Frame_3706",
  "Frame_3707",
];
const Partners = memo(() => {
  const { t } = useCustomTranslation();
  return (
    <HomeSection classNames="partners animate">
      <h2
        dangerouslySetInnerHTML={{
          __html:
            "LEAD THE <em>TRUSTLESS AI</em> Revolution <em>TOGETHER.</em>",
        }}
      />
      {[partnerList01, partnerList02, partnerList03].map((list, listIndex) => (
        <PartnerCarousel key={listIndex} partners={list} index={listIndex} />
      ))}
      <div className="partners_bg1" />
      <div className="partners_bg2" />
    </HomeSection>
  );
}, isEqual);
export default Partners;
